import { mapPinColours, defaultPinColour } from "./common"
import { InlineLoading } from "web/components"

const MAX_CATEGORIES = 8

export default function Legend({ title, categories, isLoading }) {
  function getLabel(category) {
    if (category.label) return category.label
    if (typeof category.value === "boolean") {
      return category.value ? "Yes" : "No"
    }
    return category.value
  }

  return (
    <div className="rounded-md bg-white text-xs shadow-altrio-1">
      <div className="rounded-t-md bg-neutral-9 p-2 text-neutral-2">
        {title}
      </div>
      {!isLoading ? (
        <div className="space-y-1 p-2">
          {categories.slice(0, MAX_CATEGORIES).map((category, i) => (
            <div
              key={i}
              className="pl-2"
              style={{ borderLeftWidth: "20px", borderColor: mapPinColours[i] }}
            >
              {getLabel(category)}
            </div>
          ))}
          <div
            className="pl-2"
            style={{ borderLeftWidth: "20px", borderColor: defaultPinColour }}
          >
            Other / Unknown
          </div>
        </div>
      ) : (
        <div className="flex justify-center space-y-1 p-2">
          <InlineLoading />
        </div>
      )}
    </div>
  )
}
